import type { Client, RequestContext } from "../client";
import type { DeprecationsConfigurationResource, ModifyDeprecationsConfigurationCommand } from "../resources/deprecationsConfigurationResource";
export class DeprecationsConfigurationRepository {
    constructor(private readonly client: Client, private readonly requestContext: RequestContext) {
        this.client = client;
    }
    get(): Promise<DeprecationsConfigurationResource> {
        return this.client.get(this.requestContext, `~/api/deprecationsconfiguration`);
    }
    save(model: ModifyDeprecationsConfigurationCommand): Promise<DeprecationsConfigurationResource> {
        return this.client.post(this.requestContext, `~/api/deprecationsconfiguration`, model);
    }
}
